import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SensorTypeFormatterService {
  formatSensorType(sensorType: string): string {
    return sensorType.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
  }
}
